// extracted by mini-css-extract-plugin
export default {"container":"Skeleton-module__container-PH25N7","placeholder":"Skeleton-module__placeholder-Tjjupe"};